// extracted by mini-css-extract-plugin
var _1 = "FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _2 = "FileIconPlaceholder-modulesize100__SFdD2";
var _3 = "FileIconPlaceholder-modulesize24__Dioni";
var _4 = "FileIconPlaceholder-modulesize32__sFZ_C";
var _5 = "FileIconPlaceholder-modulesize40__yHYjt";
var _6 = "FileIconPlaceholder-modulesize44__BMmJ2";
var _7 = "FileIconPlaceholder-modulesize64__Qcqja";
export { _1 as "fileIconPlaceholder", _2 as "size100", _3 as "size24", _4 as "size32", _5 as "size40", _6 as "size44", _7 as "size64" }
